import { IIconButtonProps, IProps as IButtonProps } from "@components/button/Button";
import Skeleton from "@components/skeleton/Skeleton";
import React from "react";

import TestIds from "../../testIds";

const ButtonSkeleton: React.FunctionComponent<Partial<IButtonProps>> = (props) => {
    if (props.isTransparent) {
        return <Skeleton width={"78px"}
                         height={"16px"}
            // hack to make margin between transparent buttons larger
                         style={{
                             clipPath: "inset(0% 19px 0% 0% round 3px)"
                         }}
                         testid={TestIds.Button}>
        </Skeleton>;
    }

    return <Skeleton width={"100px"}
                     height={"38px"}
                     borderRadius={"19px"}
                     testid={TestIds.Button}/>;
};

export default ButtonSkeleton;

export const IconButtonSkeleton: React.FunctionComponent<Partial<IIconButtonProps>> = (props) => {
    return <Skeleton width={"38px"}
                     height={"38px"}
                     borderRadius={"50%"}
                     testid={TestIds.IconButton}/>;
};
